<template>
  <div>
    <div class="mb-2">
      <DrugSearchNew
        :onSelect="(d) => addDrug(d)"
      />
    </div>
    <div v-if="loadingList || drugsForSelect.length">
      <h5>Рекоммендуемые препараты</h5>
      <pulse-loader :loading="loadingList" :color="$constants.LOADING_COLOR" class="text-center"/>
      <div v-for="(d, i) in drugsForSelect" class="flex mt-1 border pl-2 align-items-center bg-gray">
        <span class="flex-grow-1 mb-0 pr-1">{{ d.title }}</span>
        <button @click="addDrug(d)" class="btn btn-default" type="button">привязать <i
          class="icon-fa icon-fa-arrow-circle-down"/>
        </button>
      </div>
      <hr>
    </div>
    <h5>Привязанные препараты</h5>
    <div v-for="(d, i) in drugs" v-if="!d.to_delete" class="flex mt-1 border pl-2 align-items-center bg-gray">
      <label class="flex-grow-1 mb-0 pr-1">
        <input v-if="drugs.length > 1" class="mr-2" type="radio" v-model="mainDrug" :value="d.drug.id">
        <span class="">{{ d.drug.title }}</span>
      </label>
      <button @click="removeDrug(d.id)" class="btn btn-default" type="button"><i
        class="icon-fa icon-fa-remove"/>
      </button>
    </div>
    <!--    <div class="mt-2 text-right">-->
    <!--      <LoadingButton-->
    <!--        title="Сохранить изменения"-->
    <!--        :loading="btnLoading"-->
    <!--        :color="$constants.SUCCESS_COLOR"-->
    <!--        :onClick="() => updatePairRecords()"-->
    <!--        className="btn btn-outline-success"-->
    <!--      />-->
    <!--    </div>-->
  </div>
</template>

<script>

import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import {customUpdateData} from "@/eventsBus";

export default {
  components: {LoadingButton, DrugSearchNew},
  props: ['taskData', 'pairedDrugs', 'drug'],
  data() {
    return {
      btnLoading: false,
      loadingList: false,
      drugs: [],
      drugsForSelect: [],
      mainDrug: 0,
    }
  },
  async created() {
    await this.getPairedDrugs();
    this.mainDrug = this.drugs.find((d) => d.is_main)?.drug?.id ?? 0;
    await this.getRecommendedDrugs();
  },
  methods: {
    async getPairedDrugs() {
      const {data} = await api.index('/new/drugs/relations/sm/' + this.drug.id);
      if (data.success) {
        this.drugs = data.pairedDrugs ?? [];
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Неуспешно!')
      }
    },
    async updatePairRecords() {
      const sentData = this.validate();
      if (!sentData.success) {
        toastr['warning'](sentData.message, 'Ошибка!')
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/new/drugs/relations/sm/update', {
        object_id: this.drug.id,
        ...sentData.data
      });
      if (data.success) {
        toastr['success']('сохранено', 'Успешно!')
        this.drugs = this.drugs.filter((d) => !d.to_delete);
        await this.getRecommendedDrugs();
        customUpdateData.$emit(
          'updateDrugInMSStatList',
          {
            drug_id: this.drug.id,
            related_drugs: [...this.drugs]
          }
        );
        customUpdateData.$emit(
          'updateMSPairedDrugs', {}
        );
      } else {
        toastr['warning'](data.message ?? 'Ошибка!')
      }
      this.btnLoading = false;
    },
    async getRecommendedDrugs() {
      this.loadingList = true;
      const {data} = await api.post('/new/drugs/search', {
        searchTitle: this.drug.title.split(' ')[0],
        noPrices: true,
      });
      if (data.success) {
        const pairedIds = (this.drugs ?? []).map((p) => p.drug.id);
        this.drugsForSelect = data.drugs.filter((d) => !pairedIds.includes(d.id));
      }
      this.loadingList = false;
    },
    validate() {
      if (!this.drugs.length) return {success: false, message: 'Не выбраны препараты для связки'};
      return {
        success: true, data: {
          drugs: this.drugs.map((d) => {
            return {
              record_id: d.id,
              drug_id: d.drug.id,
              to_delete: d.to_delete
            }
          }),
          mainDrugId: this.mainDrug
        }
      };
    },
    removeDrug(recordId) {
      const index = this.drugs.findIndex((d) => d.id === recordId);
      if (this.drugs[index].drug.id === this.mainDrug) {
        this.mainDrug = 0;
      }
      if (this.drugs[index].id) {
        this.drugs[index].to_delete = 1;
      } else {
        delete this.drugs[index];
        this.drugs = this.drugs.filter((d) => d);
      }
      this.drugs = [...this.drugs];
      this.updatePairRecords();
    },
    addDrug(d) {
      if (d && !this.drugs.find((dd) => dd.drug.id === d.id)) {
        this.drugs.push({drug: d});
        const pairedIds = (this.drugs ?? []).map((p) => p.drug.id);
        this.drugsForSelect = this.drugsForSelect.filter((d) => !pairedIds.includes(d.id));
        this.updatePairRecords();
      }
    }
  }
}

</script>
